export default "__VITE_ASSET__b$47HXKK__"